__turbopack_context__.v({
  "list": "ActivityCard-module__pQOaoW__list",
});
